import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import Footer from "./Footer";
import Navigation from "./Navigation";
import "./Referral.css";
import { RWebShare } from "react-web-share";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function Referral() {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="refer-container">
      <div className="refer-header">
        <Navigation></Navigation>
      </div>
      <div className="refer-content">
        <Card sx={{ maxWidth: "75vw", padding: "0.1rem" }}>
          <CardMedia
            component="img"
            height="300"
            image="https://img.freepik.com/free-vector/referral-program-abstract-concept-vector-illustration-referral-marketing-method-friend-recommendation-acquire-new-customer-product-promotion-social-media-influencer-loyalty-abstract-metaphor_335657-2939.jpg?w=740&t=st=1660247362~exp=1660247962~hmac=08aaed336b7c4589ced6d830f89ede12198fab5094cdec5ffe005c40531ca0e9"
            alt="Styclick Referral"
          />
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              Sharing is caring, spread the love by inviting others into this
              amazing platform <br></br>
              <small>Image designed by vectorjuice</small>
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <RWebShare
              data={{
                text: "Come join me on Styclick. Styclick is the digitization of the whole sewing process to make service delivery more efficient,faster, cheaper and easier.",
                url: "https://styclick-a593d.web.app",
                sites: [
                  "facebook",
                  "twitter",
                  "whatsapp",
                  "telegram",
                  "mail",
                  "reddit",
                  "instagram",
                ],
                title: "Styclick Fashion App Referral",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <span className="refer-button-container">
                <button className="refer-button">
                  {" "}
                  <IconButton  aria-label="share">
                    <ShareIcon />
                  </IconButton>
                </button>
              </span>
            </RWebShare>
          </CardActions>
        </Card>
      </div>
      <div className="refer-footer">
        <Footer></Footer>
      </div>
    </div>
  );
}

export default Referral;
